import { render, staticRenderFns } from "./KlarnaWidget.vue?vue&type=template&id=73fe95d6"
import script from "./KlarnaWidget.vue?vue&type=script&lang=js"
export * from "./KlarnaWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports